import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { usePinnedSideBarItems } from "~/app/v1/[communitySlug]/providers/SidebarItemsProvider";

export const usePinnedItemsQuery = (
    communityId?: string,
    initialData?: string[],
) => {
    const { getPinnedItems } = usePinnedSideBarItems();

    return useQuery(
        ["pinnedItems", communityId],
        () => getPinnedItems(communityId),
        {
            enabled: !!communityId,
            initialData: initialData ?? [],
        },
    );
};

export const usePinnedItemsMutation = (communityId: string) => {
    const queryClient = useQueryClient();
    const { updatePinnedItems } = usePinnedSideBarItems();

    return useMutation(
        (newMenuItems: string[]) =>
            updatePinnedItems({ communityId, newMenuItems }),
        {
            onMutate: async (newMenuItems) => {
                await queryClient.cancelQueries(["pinnedItems", communityId]);

                const previousPinnedItems = queryClient.getQueryData([
                    "pinnedItems",
                    communityId,
                ]);

                queryClient.setQueryData(
                    ["pinnedItems", communityId],
                    () => newMenuItems,
                );

                return { previousPinnedItems };
            },
            onError: (error, newMenuItems, context) => {
                if (context?.previousPinnedItems) {
                    queryClient.setQueryData(
                        ["pinnedItems", communityId],
                        context.previousPinnedItems,
                    );
                }
                console.error("Failed to update pinned items:", error);
            },
        },
    );
};
